import React, { useState } from 'react';
import { Gamepad2, Menu, X } from 'lucide-react';

const pages = ['Inicio', 'Trabajos', 'Experiencia', 'Cursos'];

export default function Navbar({ currentPage, onNavigate }) {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const handleNav = (index) => {
    onNavigate(index);
    setIsMobileOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50">
      {/* Glass background */}
      <div className="absolute inset-0 bg-dark-950/80 backdrop-blur-xl border-b border-white/[0.04]" />

      {/* Content */}
      <div className="relative flex items-center justify-between px-6 lg:px-12 h-16 lg:h-20 max-w-7xl mx-auto">
        {/* Logo */}
        <button
          onClick={() => handleNav(0)}
          className="flex items-center gap-3 group"
        >
          <div className="relative">
            <div className="w-9 h-9 lg:w-10 lg:h-10 rounded-xl bg-gradient-to-br from-accent-blue to-accent-purple flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-accent-blue/25">
              <Gamepad2 className="w-4 h-4 lg:w-5 lg:h-5 text-white" />
            </div>
            {/* Glow ring */}
            <div className="absolute -inset-1 rounded-xl bg-gradient-to-br from-accent-blue/20 to-accent-purple/20 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          </div>
          <span className="font-display font-bold text-base lg:text-lg text-white tracking-tight">
            Euclides <span className="text-gradient-blue">Martinez</span>
          </span>
        </button>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-1">
          {pages.map((item, index) => (
            <button
              key={item}
              onClick={() => handleNav(index)}
              className={`nav-link ${currentPage === index ? 'active' : ''}`}
            >
              {item}
            </button>
          ))}
        </div>

        {/* Mobile Hamburger */}
        <button
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          className="lg:hidden relative w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-gray-300 hover:text-white hover:bg-white/10 hover:border-accent-blue/30 transition-all duration-300"
          aria-label="Toggle menu"
        >
          {isMobileOpen ? (
            <X className="w-5 h-5" />
          ) : (
            <Menu className="w-5 h-5" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden transition-all duration-400 ease-out overflow-hidden ${
          isMobileOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-dark-900/95 backdrop-blur-xl border-b border-white/5 px-6 py-4 space-y-1">
          {pages.map((item, index) => (
            <button
              key={item}
              onClick={() => handleNav(index)}
              className={`w-full text-left px-4 py-3 rounded-xl text-sm font-medium transition-all duration-300 ${
                currentPage === index
                  ? 'bg-gradient-to-r from-accent-blue/10 to-accent-purple/10 text-white border border-accent-blue/20'
                  : 'text-gray-400 hover:text-white hover:bg-white/5'
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
